import React from 'react';
import '../styles/AccentBadge.css';

function AccentBadge(props) {
    const val = props.val;
    const bg = props.bg;
    const freeSize = props.freeSize;
    const clickFunc = props.clickFunc;

    return (
        <div 
            className={"accent-badge-element-container " + (freeSize === false ? "accent-badge-element-normal-size " : "accent-badge-element-free-size ") + (bg)}
            onClick={() => clickFunc === null ? null : clickFunc()}
        >
            <span className="label-bold-caps colour-white block-text text-align-center">
                {val}
            </span>
        </div>
    )
};

export default AccentBadge;